<template>
<div class="add-confirm-view">
        <div class="add-confirm">
            <div class="add-confirm-top">
                <div class="add-confirm-top-back-btn" @click.stop="backToManageView">
                    <img src="@/assets/img/share/icon_file_manage_back.png"/>
                </div>
                <div class="add-confirm-top-title">{{$t("添加协作者")}}</div>
            </div>

            <div v-if="myAuth === 'ALL'" ref="inputContainer" class="popover-share-search" @mouseenter="hoverInput(true)" @mouseleave="hoverInput(false)">
                <div class="member-input">
                    <a-trigger position="bl" trigger="focus" v-model="searchText" :click-outside-to-close="false" :blur-to-close="false">
                        <div ref="searchInput" class="search-input" contenteditable="true" :data-placeholder="$t('搜索用户添加权限')" @input="searchMembers" @focus="searchInputFocus" @blur="handleBlur" @keydown="handleKeyDown"></div>
                        <template #content>
                            <FileShareSearchView v-show="showSearchResult" :width="'368px'" :searchText="searchText" :originData="originData" @selectMember="selectMember"></FileShareSearchView>
                        </template>
                    </a-trigger>
                    <div v-show="searchText" class="clear-btn" @click.stop="clearText">
                        <svg-icon name="header-file_transfer_input_clear" class="clear-icon"></svg-icon>
                    </div>
                </div>
            </div>

            <FileShareAddBatchModifyAuth @selectBatchAuth="selectBatchAuth"></FileShareAddBatchModifyAuth>

            <div class="add-confirm-center">
                <div class="add-confirm-worker-item" v-for="(item, index) in this.shouldAddMemberList">
                    <div class="worker-avatar">
                        <!-- 0:用户 1:部门 2：用户组  3： IM群组-->
                        <div v-if="
                                item.type === 0 &&
                                    (item.memberAvatar === '' ||
                                        item.memberAvatar === undefined ||
                                        item.memberAvatar === null)
                            " class="user-avatar" :style="avatarColorStye(item.memberName)">
                            <div class="user-name">
                                {{ userName(item.memberName) }}
                            </div>
                        </div>
                        <img v-else :src="fileAvatar(item)"/>
                    </div>
                    <div class="worker-info">
                        <div v-if="shouldAddMemberName(item).length < 11" class="worker-name">
                            {{ shouldAddMemberName(item) }}
                        </div>
                        <a-tooltip v-else :content="shouldAddMemberName(item)" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow">
                            <div class="worker-name">
                                {{ shouldAddMemberName(item) }}
                            </div>
                        </a-tooltip>
                        <div v-if="
                                item.spaceId &&
                                    spaceId !== item.spaceId &&
                                    item.spaceName
                            " class="worker-space-name">
                            @{{ item.spaceName }}
                        </div>
                    </div>
                    <a-dropdown class="dropdown-auth-confirm" trigger="click" position="br" @select="cmd => handlerChangeAuth(cmd, index)" @popup-visible-change="(v: boolean) => dropdownMenuVisibleChange(v, index)">
                        <div class="worker-auth-editable" @click="openAuthList(index)" @mouseover="mouseAction(index, true)" @mouseleave="mouseAction(index, false)">
                            {{ authName(item.auth) }}
                            <img :src="changeEditableIcon(index)"/>
                        </div>
                        <template #content>
                            <div class="auth-list" v-for="(auth, i) in authList" :key="i">
                                <a-doption :value="i" :divided="
                                        ['ALL', 'DELETE'].includes(auth.id)
                                    " :disabled="
                                        item.edit === false ||
                                            isDisabledAuth(auth)
                                    ">
                                    <div class="auth-name" :style="computedAuthStyle(auth, item)">
                                        <img v-show="
                                                auth.id === item.auth &&
                                                    !isDisabledAuth(auth)
                                            " src="@/assets/img/share/icon_file_selected.png"/>{{ auth.name }}
                                    </div>
                                    <div class="auth-desc">{{ auth.desc }}</div>
                                </a-doption>
                            </div>
                        </template>
                    </a-dropdown>
                </div>
            </div>
        </div>
        <div class="add-confirm-bottom">
            <div class="push-message">
                <span>
                    <a-checkbox v-model="pushMessage">
                        <span class="text" :class="messageClass">{{$t("发送通知消息")}}</span>
                    </a-checkbox>
                </span>
            </div>
            <div class="add-confirm-bottom-cancel-btn" @click="backToManageView">{{$t("取消")}}            </div>
            <div class="add-confirm-bottom-add-btn" @click="addMembers">{{$t("添加")}}            </div>
        </div>
        <a-modal class="file-share-common-dialog" v-model:visible="showDialog" :simple="true" :footer="false" :render-to-body="false">
            <div class="content">
                <div class="title">
                    <img src="@/assets/img/share/icon_file_tip.png"/>{{$t("提示")}}                </div>
                <div class="desc">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。")}}                </div>
                <div class="bottom">
                    <div class="cancel-btn" @click="showDialog = pushMessage = false">{{$t("取消")}}                    </div>
                    <div class="confirm-btn" @click="addConfirm">{{$t("确认发送")}}</div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { setFileAuth } from '../../core/api/file';
import { AUTH_DETAIL_LIST } from '../../constants/FileShare';
import nameColor from '../../utils/nameColor';
import DepartmentAvatar from '../../assets/img/share/icon_file_file.png';
import { reactive } from 'vue';
import FileShareSearchView from './FileShareSearchView.vue';

import EditableSelectedIcon from '@/assets/img/share/icon_file_auth_editable_selected.png';
import EditableHoverIcon from '@/assets/img/share/icon_file_auth_editable_hover.png';
import EditableIcon from '@/assets/img/share/icon_file_auth_editable.png';
import { setSaviorConfigure, updateSaviorData } from '../../utils/savior';
import GroupAvatar from '@/assets/img/share/fp_user_group.png';
import UnitedDepartmentAvatar from '@/assets/img/share/finder_dept_sub_united.png';
import FileShareAddBatchModifyAuth from './FileShareAddBatchModifyAuth.vue';

export default {
  name: 'FileShareAddConfirmView',
  components: {
    FileShareSearchView,
    FileShareAddBatchModifyAuth },

  props: {
    fileId: {
      type: String },

    addData: {
      type: Array },

    originData: {
      type: Array },

    spaceId: {
      type: String },

    nonAdminMaxAuth: {
      type: String,
      default: '' },

    myAuth: {
      type: String } },


  data() {
    return {
      shouldAddMemberList: reactive(this.addData),
      editableHover: reactive([]),
      editableFocus: reactive([]),
      authList: reactive(AUTH_DETAIL_LIST),
      pushMessage: true,
      showDialog: false,
      searchText: ('' as string),
      isFocus: (false as boolean),
      selectedMember: (null as any),
      showSearchResult: (true as boolean),
      defaultBatchAuth: ('READ_DOWNLOAD' as string) };

  },
  computed: {
    messageClass() {
      return this.pushMessage ? '' : 'disable';
    },
    shouldAddMemberName() {
      return (item: any) => {
        if (item.type === 0) {
          return item.memberName;
        } else if (item.type === 1) {
          return item.departmentName;
        } else {
          return item.name;
        }
      };
    } },

  created() {
    for (let i = 0; i < this.shouldAddMemberList.length; i++) {
      this.editableHover.push(false);
      this.editableFocus.push(false);
    }
    this.shouldAddMemberList.map((item: any) => {
      if (!item.auth) {
        item.auth = 'READ_DOWNLOAD';
      }
      if (item.type !== 0) {
        this.pushMessage = false;
      }
    });
    this.authList = this.authList.filter((i: any) => i.id !== 'NONE');
  },
  methods: {
    selectBatchAuth(authId) {
      this.defaultBatchAuth = authId;
      this.shouldAddMemberList.forEach((item: any) => {
        item.auth = authId;
      });
    },
    isDisabledAuth(auth: any) {
      if (this.nonAdminMaxAuth) {
        const newAuthList = this.authList.filter(
        (i: any) =>
        i.id !== 'NONE' &&
        i.id !== 'DELETE' &&
        i.id !== 'RECOVER');

        const maxAuthIndex = newAuthList.findIndex(
        (i: any) => i.id === this.nonAdminMaxAuth);

        const authIndex = newAuthList.findIndex(
        (i: any) => i.id === auth.id);

        return maxAuthIndex < authIndex;
      } else {
        return false;
      }
    },
    computedAuthStyle(auth: any, item: any) {
      const disabledStyle =
      'color: #CCCED7 !important; margin-left: 36px';
      const activeStyle = 'color: #5C70FF !important';
      const normalStyle = 'color: #222329 !important; margin-left: 36px';
      const specailStyle = 'color: #FF4747 !important; margin-left: 36px';
      const specailActiveStyle = 'color: #FF4747 !important;';

      if (['DELETE'].includes(auth.id)) {
        if (auth.id === item.auth) {
          return specailActiveStyle;
        } else {
          return specailStyle;
        }
      } else {
        const disabled: boolean = this.isDisabledAuth(auth);
        if (disabled) {
          return disabledStyle;
        }
        if (auth.id === item.auth) {
          return activeStyle;
        } else {
          return normalStyle;
        }
      }
    },
    backToManageView() {
      this.$emit('backToManageView');
    },
    authName(auth: string) {
      switch (auth) {
        case 'ALL':
          return intl.$t("所有权限");
        case 'READ':
          return intl.$t("仅查看");
        case 'READ_DOWNLOAD':
          return intl.$t("查看下载");
        case 'WRITE':
          return intl.$t("编辑");}

    },
    handlerChangeAuth(command: any, index: number) {
      if (this.authList[command].id === 'DELETE') {
        /// 删除协作者
        this.shouldAddMemberList.splice(index, 1);
        if (this.shouldAddMemberList.length === 0) {
          this.backToManageView();
        } else {
          if (
          !this.shouldAddMemberList.some(
          (item: any) => item.type !== 0))

          {
            this.pushMessage = true;
          }
        }
      } else {
        this.shouldAddMemberList[index].auth = this.authList[
        command].
        id;
      }
    },
    openAuthList(index: number) {
      this.editableFocus[index] = !this.editableFocus[index];
      if (!this.editableFocus[index]) {
        return;
      }
    },
    dropdownMenuVisibleChange(visible: boolean, index: number) {
      if (!visible) {
        this.editableFocus[index] = visible;
        this.editableHover[index] = visible;
      }
    },
    mouseAction(index: number, isHover: boolean) {
      if (this.editableFocus[index] === true && !isHover) {
        this.editableHover[index] = true;
        return;
      }
      this.editableHover[index] = isHover;
    },
    changeEditableIcon(index: number) {
      return this.editableFocus[index] ?
      EditableSelectedIcon :
      this.editableHover[index] ?
      EditableHoverIcon :
      EditableIcon;
    },
    addMembers() {
      if (
      this.shouldAddMemberList.some(
      (item: any) => item.type !== 0 && this.pushMessage))

      {
        this.showDialog = true;
      } else {
        this.addConfirm();
      }
    },
    addConfirm() {
      setSaviorConfigure({
        expandfield: {
          source: 'docs',
          fid: this.fileId } });


      updateSaviorData({
        eventtype: 'click',
        category: 'cloud_document',
        label: 'add_collaborator',
        eventid: 'cloud_document_operation' });

      setSaviorConfigure({ expandfield: {} });

      this.showDialog = false;
      /// 修改权限
      const fileId = this.fileId;
      let confirmAddList = [];
      this.shouldAddMemberList.map((item: any) => {
        let toType = '';
        let to = '';
        switch (item.type) {
          case 0:
            toType = 'PERSON';
            to = item.userId;
            break;
          case 1:
            toType = 'DEPARTMENT';
            to = item.departmentId;
            break;
          case 2:
            toType = 'USER_GROUP';
            to = item.id;
            break;
          case 3:
            toType = 'GROUP';
            to = item.id;}

        confirmAddList.push({
          auth: item.auth,
          to: to,
          toSpace: item.spaceId ?? this.spaceId,
          toType: toType });

      });
      const data = {
        fileId: fileId,
        list: confirmAddList,
        pushMessage: this.pushMessage };

      setFileAuth(data).
      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          this.$message.success(intl.$t("添加协作者成功"));
          setTimeout(() => {
            this.backToManageView();
          }, 600);
        } else {
          this.$message.error(intl.$t(`添加协作者失败，{message}`, { message: message }));
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("添加协作者失败"));
      });
    },
    fileAvatar(item: any) {
      // 0:用户 1:部门 2：用户组  3： IM群组
      if (item.type === 0) {
        return item.memberAvatar;
      } else if (item.type === 2) {
        return GroupAvatar;
      } else if (item.type === 3) {
        return item.avatar;
      } else if (item.type === 1 && item.spaceId !== this.spaceId) {
        return UnitedDepartmentAvatar;
      } else {
        return DepartmentAvatar;
      }
    },
    avatarColorStye(name: string) {
      let avatarColor = nameColor.getNameColor(name);
      return `background-color: ${avatarColor}`;
    },
    userName(name: string) {
      return nameColor.getLastName(name);
    },
    hoverInput(isHover: boolean) {
      if (isHover) {
        this.inputContainerBorderStyle(true);
      } else {
        if (!this.isFocus) {
          this.inputContainerBorderStyle(false);
        }
      }
    },
    selectMember(item: any) {
      this.showSearchResult = false;
      this.selectedMember = item;
      this.$refs.searchInput.innerText = this.searchText = '';
      this.inputContainerBorderStyle(false);
      this.isFocus = false;

      let isOwner: boolean = false;
      let isAdmin: boolean = false;
      let exsitMember: any = this.originData.find((member: any) => {
        if (
        member.toSpace === item.spaceId &&
        member.to === item.userId && (
        member.memberIdentity === 'ADMIN' ||
        member.memberIdentity === 'OWNER'))
        {
          if (member.memberIdentity === 'ADMIN') {
            isAdmin = true;
          } else if (member.memberIdentity === 'OWNER') {
            isOwner = true;
          }
        }
        return (
          member.toSpace === item.spaceId && member.to === item.userId);

      });

      if (exsitMember) {
        if (isOwner) {
          this.$message.warning(intl.$t("该用户为文档所有者，请勿重复添加"));
          return;
        } else if (isAdmin) {
          this.$message.warning(intl.$t("该用户为管理员，请勿重复添加"));
          return;
        }
      }

      let isExsit = this.shouldAddMemberList.some((member: any) => {
        return (
          member.spaceId === item.spaceId &&
          member.userId === item.userId);

      });

      if (isExsit) {
        this.$message.warning(intl.$t("该用户已添加，请勿重复添加"));
        return;
      }

      this.shouldAddMemberList.unshift({
        memberName: item.memberName,
        memberAvatar: item.memberAvatar,
        memberUniqueId: item.id,
        spaceId: item.spaceId,
        type: 0,
        userId: item.userId,
        spaceName: item.spaceName,
        auth: exsitMember ? exsitMember.auth : this.defaultBatchAuth ? this.defaultBatchAuth : 'READ_DOWNLOAD' });

    },
    searchMembers(event) {
      this.selectedMember = null;
      this.showSearchResult = true;
      this.searchText = event.target.innerText;
    },
    searchInputFocus() {
      this.isFocus = true;
      this.inputContainerBorderStyle(true);
      this.handleRange();
    },
    handleRange() {
      this.$nextTick(() => {
        const range = document.createRange();
        const sel = window.getSelection();
        this.$refs.searchInput.focus();
        const childNodes = this.$refs.searchInput.childNodes;
        if (childNodes.length > 0) {
          const lastNode = childNodes[childNodes.length - 1];
          range.setStart(lastNode, lastNode.length || 0);
          range.collapse(true);
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      });
    },
    handleBlur() {
      this.isFocus = false;
      if (this.searchText) {
        this.inputContainerBorderStyle(false);
        setTimeout(() => {
          this.showSearchResult = false;
        }, 200);
      } else {
        this.inputContainerBorderStyle(false);
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    },
    clearText() {
      this.$refs.searchInput.innerText = this.searchText = '';
      this.$refs.searchInput.focus();
    },
    inputContainerBorderStyle(hasBorder: boolean) {
      if (hasBorder) {
        this.$refs.inputContainer.style.border = '1px solid #5C70FF';
      } else {
        this.$refs.inputContainer.style.border = '1px solid #D1D3D6';
      }
    } } };
</script>

<style lang="scss" scoped>
.add-confirm-view {
    display: flex;
    flex-direction: column;
    flex: 1;

    .add-confirm {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin: 16px 16px 0px 16px;

        .add-confirm-top {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            line-height: 100%;
            margin-bottom: 24px;

            .add-confirm-top-back-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                margin-right: 4px;
                cursor: pointer;

                img {
                    width: 14px;
                    height: 14px;
                    object-fit: contain;
                }

                &:hover {
                    background-color: #f4f6f9;
                    border-radius: 4px;
                }
            }

            .add-confirm-top-title {
                display: flex;
                flex: 1;
                font-size: 16px;
                font-weight: 500;
                color: #121317;
                line-height: 100%;
            }
        }

        .popover-share-search {
            margin-bottom: 8px;
            width: 100%;
            height: 32px;
            box-sizing: border-box;
            border: 1px solid #d1d3d6;
            border-radius: 6px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            .member-input {
                width: 100%;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                position: relative;

                .search-input {
                    display: inline-flex;
                    flex: 1;
                    padding: 6px 12px;
                    background: transparent;
                    border: none;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    color: #121317;
                    text-align: left;

                    &:empty::before {
                        content: attr(data-placeholder);
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #8f959e;
                        letter-spacing: 0;
                        line-height: 20px;
                        cursor: text;
                    }

                    &:focus-visible {
                        outline: none;
                    }
                }

                .clear-btn {
                    width: 16px;
                    height: 16px;
                    padding-right: 12px;
                    display: flex;
                    cursor: pointer;

                    .clear-icon {
                        width: 16px;
                        height: 16px;
                    }
                }
            }
        }

        .add-confirm-center {
            display: flex;
            flex-direction: column;
            max-height: 160px;
            overflow-x: hidden;
            overflow-y: auto;

            &::-webkit-scrollbar {
                display: none;
            }

            .add-confirm-worker-item {
                width: 100%;
                height: 40px;
                margin-bottom: 8px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                flex-shrink: 0;
                cursor: pointer;

                &:hover {
                    background-color: #f4f6f9;
                    border-radius: 8px;
                }

                .worker-avatar {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    margin-right: 12px;
                    margin-left: 4px;

                    img {
                        width: 32px;
                        height: 32px;
                        border-radius: 8px;
                    }

                    .user-avatar {
                        width: 32px;
                        height: 32px;
                        border-radius: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .user-name {
                            font-weight: 600;
                            font-size: 12px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 17px;
                        }
                    }
                }

                .worker-info {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    flex: 1;
                    height: 100%;
                    margin-right: 4px;

                    .worker-name {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #323233;
                        letter-spacing: 0;
                        line-height: 20px;
                        margin-right: 8px;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    .worker-space-name {
                        margin-left: 4px;
                        color: #fc7d29;
                        font-family: PingFangSC-Regular;
                        font-weight: 300;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 20px;
                        display: flex;
                        flex-shrink: 0;
                    }
                }

                .worker-auth-editable {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    height: 32px;
                    padding: 0 8px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    letter-spacing: 0;
                    text-align: center;
                    line-height: 20px;
                    border: none;
                    background-color: transparent;
                    cursor: pointer;

                    &:hover {
                        color: #5c70ff;
                    }

                    img {
                        margin-left: 4px;
                        width: 10px;
                        height: 10px;
                        object-fit: contain;
                    }

                    .editable-icon {
                        margin-left: 4px;
                        width: 10px;
                        height: 10px;
                    }
                }
            }
        }
    }

    .add-confirm-bottom {
        height: 52px;
        width: 100%;
        background-color: #f5f6f7;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        border-radius: 0 0 10px 10px;

        .push-message {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: space-between;
            margin-left: 16px;

            .text {
                color: #222329;
                line-height: 30px;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
            }

            .disable {
                color: #222329;
            }
        }

        .add-confirm-bottom-cancel-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;
            color: #222329;
            line-height: 20px;
            background-color: #ffffff;
            width: 68px;
            height: 36px;
            border-radius: 8px;
            border: 1px solid #e6e8ec;

            &:hover {
                background-color: #f4f6f9;
            }
        }

        .add-confirm-bottom-add-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;
            color: #fff;
            line-height: 20px;
            background-color: #5c70ff;
            width: 68px;
            height: 36px;
            border-radius: 8px;

            &:hover {
                background-color: #6d7dff;
            }
        }
    }
}

// .custom_tooltip_css {
//     border-radius: 8px;
//     color: #767c85;
//     font-size: 14px;
//     font-weight: 400;
//     padding: 8px;
//     background-color: #ffffff;
//     box-shadow: 0 8px 12px 0 #1213171a !important;
// }

// .custom_tooltip_css_arrow {
//     background-color: transparent;
// }
</style>

<style lang="scss">
// @import './theme/commonDialog.scss';
// @import './theme/dropDownAuth.scss';
.file-share-common-dialog {
    z-index: 3000 !important;

    .arco-modal {
        width: 448px;
        background: #ffffff;
        border-radius: 16px;
        padding: 0;
        overflow: hidden;
        z-index: 3001;

        .arco-modal-header {
            margin-bottom: 0;
        }

        .arco-modal-body {
            overflow: hidden;
            width: 100%;
            height: 100%;

            .content {
                margin: 24px 24px 24px 24px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;

                .title {
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000d9;
                    letter-spacing: 0;
                    line-height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 8px;
                    }
                }

                .desc {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #121317;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin-top: 16px;
                    margin-left: 24px;
                }

                .bottom {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 32px;
                    width: 100%;

                    .cancel-btn {
                        width: 76px;
                        height: 32px;
                        margin-right: 12px;
                        background: #ffffff;
                        border: 1px solid #e8e9ee;
                        border-radius: 4px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #222329;
                        text-align: center;
                        line-height: 20px;

                        &:hover {
                            background: #f4f6f9;
                            border: 1px solid #e8e9ee;
                            border-radius: 4px;
                        }
                    }

                    .confirm-btn {
                        width: 76px;
                        height: 32px;
                        background: #5c70ff;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 14px;
                        color: #ffffff;
                        text-align: center;
                        line-height: 20px;
                        border-radius: 4px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &:hover {
                            background: #6d7dff;
                            border-radius: 4px;
                        }
                    }
                }
            }
        }
    }
}

.dropdown-auth-confirm {
    z-index: 3001 !important;

    .arco-dropdown {
        margin-right: 8px !important;
        padding: 0 !important;
        background: #ffffff !important;
        border: 1px solid #e6e8ec !important;
        box-shadow: 0 8px 12px 0 #1213171a !important;
        border-radius: 8px !important;
        width: 258px !important;

        .arco-dropdown-list-wrapper {
            max-height: none !important;

            .arco-dropdown-option {
                min-height: 28px !important;
                padding: 0 0 !important;
                margin: 4px 4px 4px 4px !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                justify-content: center !important;
                line-height: 100% !important;
                width: inherit !important;
                cursor: pointer;

                &:hover {
                    background-color: #f4f6f9 !important;
                    border-radius: 8px !important;
                }

                .arco-dropdown-option-content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .auth-name {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                        font-family: PingFangSC-Regular !important;
                        color: #222329 !important;
                        line-height: 20px;
                        margin-top: 4px;

                        img {
                            width: 15px;
                            height: 11px;
                            margin: 0 11px;
                        }
                    }

                    .auth-desc {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 12px;
                        color: #a5a7b3;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin: 0 16px 4px 36px;
                        white-space: pre-wrap !important;
                        word-wrap: break-word;
                    }
                }
            }
        }

        .arco-scrollbar-track {
            display: none;
        }
    }
}
</style>
